import { Image } from "@next-platform/client-common-spicy-ui";
import { useCallback, useState } from "react";

import AvatarWithModal from "@/components/common/AvatarWithModal";
import { AvatarPreset } from "@/types";
import { cn, getAvatarUrl } from "@/utils";

interface ChatBubbleImageProps {
  imageUrl: string;
  alt: string;
  isUserMessage: boolean;
  isAvatarImageBlurred?: boolean;
  showCheckbox?: boolean;
  /** Opens the gallery details for the image; without it, the image zooms in place as before. */
  onOpenDetails?: () => void;
}

export const ChatBubbleImage = ({ imageUrl, isAvatarImageBlurred, isUserMessage, showCheckbox, alt, onOpenDetails }: ChatBubbleImageProps) => {
  const [isZoomedAvatarModalOpen, setIsZoomedAvatarModalOpen] = useState(false);

  const handleClick = useCallback(() => {
    if (showCheckbox) {
      return;
    }
    if (onOpenDetails) {
      onOpenDetails();
      return;
    }
    setIsZoomedAvatarModalOpen(true);
  }, [showCheckbox, onOpenDetails]);

  return (
    <AvatarWithModal src={imageUrl} isOpen={isZoomedAvatarModalOpen} onOpenChange={setIsZoomedAvatarModalOpen} blurred={isAvatarImageBlurred}>
      <Image
        src={
          getAvatarUrl(imageUrl, {
            preset: isUserMessage ? undefined : AvatarPreset.IMAGE_500X650,
            returnWithOriginalRatio: !!isUserMessage,
          }) as string
        }
        alt={alt}
        className={cn(
          "rounded-lg cursor-pointer !object-contain max-w-full w-full aspect-[500/650]",
          isUserMessage && "aspect-auto",
          isAvatarImageBlurred && "blur-md",
        )}
        onClick={handleClick}
        data-testid="ChatBubbleImage-Image"
      />
    </AvatarWithModal>
  );
};
